export const useSsrCampaignPage = async () => {
  const route = useRoute()
  const routeName = route?.name?.split('-_')?.[0]
  const slug = route?.params?._slug
  const screenType = useScreenType()

  const languageStore = useLanguage()
  const ipCountry = useIpCountry()
  const ssrStore = useSsrStore()
  const country = ipCountry.value || null

  const getAllData = async () => {
    const [campaignCategoriesData, campaignData, faqsData] = await Promise.all([
      getCampaignCategories(),
      getCampaigns(),
      getFaqs()
    ])

    ssrStore.value = {
      ...ssrStore.value,
      campaignCategories: campaignCategoriesData,
      campaigns: campaignData,
      faqs: faqsData
    }
  }

  async function getFaqs() {
    let result = await useCmsApi({
      endpoint: '/faqs',
      options: {
        query: {
          locale: languageStore.value,
          'sort[0]': 'order:asc',
          'filters[$and][0][name][$eq]': slug
        }
      }
    })
    return result?.data?.map(item => item?.attributes)
  }

  async function getCampaignCategories() {
    let result = await useCmsApi({
      endpoint: '/campaign-categories',
      options: {
        query: {
          locale: languageStore.value,
          'sort[0]': 'order:asc',
          'fields[0]': 'title',
          'fields[1]': 'name',
          'populate[0]': 'logo',
          'filters[$and][0][active][$eq]': 'true',
          'filters[$or][0][countries][code][$eq]': country,
          'filters[$or][1][countries][code][$null]': 'true'
        }
      }
    })

    return result?.data?.map(item => {
      let logoPath = item?.attributes?.logo?.data?.attributes

      if (logoPath?.formats?.[screenType.value]?.size < logoPath?.size) {
        logoPath = logoPath?.formats?.[screenType.value]
      }

      return {
        ...item?.attributes,
        logo: {
          src: logoPath?.url,
          alt: logoPath?.alternativeText,
          width: logoPath?.width || 'auto',
          height: logoPath?.height || 'auto'
        }
      }
    })
  }

  async function getCampaigns() {
    let query = {
      locale: languageStore.value,
      'sort[0]': 'order:asc',
      'fields[0]': 'title',
      'fields[1]': 'slug',
      'populate[img]': '*',
      'populate[logo]': '*',
      'populate[badge]': '*',
      'populate[campaign_categories]': '*',
      'filters[$and][0][$or][0][countries][code][$eq]': country,
      'filters[$and][0][$or][1][countries][code][$eq]': null
    }

    if (route?.params?._slug) {
      query['populate[seo]'] = '*'
      query['populate[campaign_inputs]'] = '*'
      query['fields[2]'] = 'content'
      query['fields[3]'] = 'startDate'
      query['fields[4]'] = 'endDate'
      query['fields[5]'] = 'campaignId'
      query['fields[6]'] = 'subTitle'
      query['fields[7]'] = 'description'
      query['fields[8]'] = 'breadcrumbText'
      query['fields[9]'] = 'pickupDate'
      query['fields[10]'] = 'dropoffDate',
      query['filters[$and][2][slug][$eq]'] = route?.params?._slug
    } else {
      query['filters[$and][1][active][$eq]'] = true
    }

    let result = await useCmsApi({
      endpoint: '/campaigns',
      options: {
        query
      }
    })

    if (route?.params?._slug) {
      let imgPath = result?.data?.[0]?.attributes?.img?.data?.attributes
      let logoPath = result?.data?.[0]?.attributes?.logo?.data?.attributes
      let badgePath = result?.data?.[0]?.attributes?.badge?.data?.attributes

      if (imgPath?.formats?.[screenType.value]?.size < imgPath?.size) {
        imgPath = imgPath?.formats?.[screenType.value]
      }
      if (logoPath?.formats?.[screenType.value]?.size < logoPath?.size) {
        logoPath = logoPath?.formats[screenType.value]
      }
      if (badgePath?.formats?.[screenType.value]?.size < badgePath?.size) {
        badgePath = badgePath?.formats[screenType.value]
      }
      return {
        ...result?.data?.[0]?.attributes,
        img: {
          src: imgPath?.url,
          alt: imgPath?.alternativeText,
          width: imgPath?.width || 'auto',
          height: imgPath?.height || 'auto'
        },
        logo: {
          src: logoPath?.url,
          alt: logoPath?.alternativeText,
          width: logoPath?.width || 'auto',
          height: logoPath?.height || 'auto'
        },
        badge: {
          src: badgePath?.url,
          alt: badgePath?.alternativeText,
          width: badgePath?.width || 'auto',
          height: badgePath?.height || 'auto'
        }
      }
    } else {
      return result?.data?.map(item => {
        let imgPath = item?.attributes?.img?.data?.attributes
        let logoPath = item?.attributes?.logo?.data?.attributes
        let badgePath = item?.attributes?.badge?.data?.attributes

        if (imgPath?.formats?.[screenType.value]?.size < imgPath?.size) {
          imgPath = imgPath?.formats?.[screenType.value]
        }
        if (logoPath?.formats?.[screenType.value]?.size < logoPath?.size) {
          logoPath = logoPath?.formats[screenType.value]
        }
        if (badgePath?.formats?.[screenType.value]?.size < badgePath?.size) {
          badgePath = badgePath?.formats[screenType.value]
        }
        return {
          ...item?.attributes,
          img: {
            src: imgPath?.url,
            alt: imgPath?.alternativeText,
            width: imgPath?.width || 'auto',
            height: imgPath?.height || 'auto'
          },
          logo: {
            src: logoPath?.url,
            alt: logoPath?.alternativeText,
            width: logoPath?.width || 'auto',
            height: logoPath?.height || 'auto'
          },
          badge: {
            src: badgePath?.url,
            alt: badgePath?.alternativeText,
            width: badgePath?.width || 'auto',
            height: badgePath?.height || 'auto'
          },
          categories: item?.attributes?.campaign_categories?.data?.map(
            x => x?.attributes?.name
          )
        }
      })
    }
  }

  try {
    await getAllData()
  } catch (error) {}
}
